routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.tunnel', {
      url: __env.routes.tunnel,
      template: `<tunnel sh-ctrl="shCtrl"></tunnel>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/tunnel/tunnel.config.js